import { toValue } from 'vue';
import { useCommonProductGetters } from '~/composables/useCommonProductGetters.js';
import { generateBreadcrumbs, getHomeCategoryBreadcrumb } from '../utils/index.js';

/**
 * Get breadcrumbs from categories
 *
 * @todo
 * move logic to pinia store module
 *
 * @description
 * This composable is used to get breadcrumbs from categories
 * in atomic ui Breadcrumb format (PrimeVue).
 *
 * @see https://primevue.org/breadcrumb/
 * @returns {{
 * breadcrumbs: import('primevue/menuitem').MenuItem[],
 * homeCategory: Category
 * }}
 */
export const useBreadcrumbs = () => {
  const { taxonomy } = useCommonProductGetters();
  const categories = toValue(taxonomy)?.categories || [];
  const breadcrumbs = generateBreadcrumbs(categories);
  const homeCategory = getHomeCategoryBreadcrumb(categories);

  return {
    breadcrumbs,
    homeCategory,
  };
};

export default useBreadcrumbs;
